const preorderFieldValidation = () => {
    const fieldWrapper = document.querySelector('[data-preorder-field]');
    if (!fieldWrapper) return;
    const input = fieldWrapper.querySelector('input');
    const addToCartButton = document.querySelector('.preorder');
    const errorMessage = fieldWrapper.querySelector('[data-preorder-message]');
    const usedNumbers = fieldWrapper.dataset.numbersArray.split(', ');
    const minValue = fieldWrapper.dataset.minValue;
    const maxValue = fieldWrapper.dataset.maxValue;
    const usedPopupValues = document.querySelectorAll('[data-properties-value]');

    input.value = '';
    fieldWrapper.classList.remove('field-valid');
    fieldWrapper.classList.remove('field-invalid');
    usedPopupValues.forEach(value => {
        usedNumbers.push(value.innerText);
    })

    input.addEventListener('input', (event) => {
        let formattedValue = parseInt(event.target.value, 10);
        if (formattedValue > 0) {
            event.target.value = String(formattedValue).padStart(4, '0');
        }
        if (!usedNumbers.includes(event.target.value) && parseInt(event.target.value) <= parseInt(maxValue) && parseInt(event.target.value) > parseInt(minValue)) {
            errorMessage.innerHTML = '';
            addToCartButton.disabled = false;
            fieldWrapper.classList.add('field-valid');
            fieldWrapper.classList.remove('field-invalid');
        } else {
            if (usedNumbers.includes(event.target.value)) {
                errorMessage.innerHTML = errorMessage.dataset.messageUnavailable;
                addToCartButton.disabled = true;
                fieldWrapper.classList.remove('field-valid');
                fieldWrapper.classList.add('field-invalid');
            } else {
                errorMessage.innerHTML = errorMessage.dataset.messageInvalid;
                addToCartButton.disabled = true;
                fieldWrapper.classList.remove('field-valid');
                fieldWrapper.classList.add('field-invalid');
            }
        }
        if (!event.target.value) {
            addToCartButton.disabled = false;
            errorMessage.innerHTML = '';
        }
    })
}

const appFieldValidation = () => {
    const engravingInput = document.querySelector('[name="properties[Add your engraving text]"]');
    if(!engravingInput) return;

    engravingInput.addEventListener('input', (e) => {
        let value = e.target.value;

        value = value.toUpperCase();
        value = value.replace(/[^A-Z\s]/g, '');
        e.target.value = value;
    });
}

const additionalCheckoutValidation = () => {
    const checkoutButton = document.querySelector('button[name="checkout"]');
    const validatedProps =  document.querySelectorAll('[data-serial-numbers]');
    const validationMessage = document.querySelector('.validation__message');

    if (validatedProps.length === 0) return;

    validationMessage.classList.remove('show');
    checkoutButton.addEventListener('click', (event) => {
        event.preventDefault();
        let includedValues = false;
        let number;

        for (const validatedProp of validatedProps ) {
            const propsArray = validatedProp.dataset.serialNumbers;
            const value = validatedProp.querySelector('[data-properties-value]');
            if (propsArray.includes(value.innerHTML)) {
                includedValues = true;
                number = value.innerHTML;
            }
        }

        if (!includedValues) {
            window.location.href = '/checkout';
        } else {
            validationMessage.classList.add('show');
            validationMessage.querySelector('span').innerHTML = number;
        }
    })
}

document.addEventListener('DOMContentLoaded', () => {
    preorderFieldValidation();
    additionalCheckoutValidation();
    setTimeout(() => {
        appFieldValidation();
    },1000)
})

document.addEventListener('cart:change', function (event) {
    setTimeout(() => {
        preorderFieldValidation();
    },1000)
});
